import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/no-array-index-key */
import { useEffect, useRef, useState, } from 'react';
import DButtonIcon from '../DButtonIcon';
import DIcon from '../DIcon';
const getItemClass = (action) => {
    const base = `dropdown-item d-flex align-items-center 
  ${action.color ? `dropdown-item-${action.color}` : ''} ${action.disabled ? 'disabled' : ''}`;
    return base;
};
export default function DDropdown({ actions, dropdownToggle, className, }) {
    const [open, setOpen] = useState(false);
    const dropdownRef = useRef(null);
    const [position, setPosition] = useState('down'); // 🆕
    // Cerrar al hacer click fuera
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);
    // 🆕 Calcular posición del menú al abrir
    useEffect(() => {
        if (open && dropdownRef.current) {
            const rect = dropdownRef.current.getBoundingClientRect();
            const spaceBottom = window.innerHeight - rect.bottom;
            const spaceRight = window.innerWidth - rect.right;
            if (spaceBottom < 150) {
                setPosition('up');
            }
            else if (spaceRight < 150) {
                setPosition('start');
            }
            else {
                setPosition('down');
            }
        }
    }, [open]);
    let ToggleElement;
    if (dropdownToggle) {
        if (typeof dropdownToggle === 'function') {
            ToggleElement = dropdownToggle({ open, toggle: () => setOpen(!open) });
        }
        else {
            ToggleElement = dropdownToggle;
        }
    }
    else {
        ToggleElement = (_jsx(DButtonIcon, { variant: "link", stopPropagationEnabled: false, onClick: () => setOpen(!open), icon: "MoreVertical" }));
    }
    return (_jsxs("div", { className: `dropdown position-relative drop-${position} ${className}`, ref: dropdownRef, children: [ToggleElement, _jsx("ul", { style: {
                    position: 'absolute',
                    top: position === 'up' ? 'auto' : '100%',
                    bottom: position === 'up' ? '100%' : 'auto',
                    left: position === 'start' ? 'auto' : 0,
                    right: position === 'start' ? '0' : 'auto',
                    transform: 'translateY(4px)',
                }, className: `dropdown-menu p-2 ${open ? 'show' : ''}`, children: actions.map((action, index) => {
                    if (action.isDivider) {
                        return (_jsx("hr", { className: "dropdown-divider" }, index));
                    }
                    return (_jsx("li", { children: action.href ? (_jsxs("a", { className: getItemClass(action), href: action.href, onClick: (e) => {
                                if (action.disabled) {
                                    e.preventDefault();
                                }
                                else {
                                    setOpen(false);
                                }
                            }, children: [action.icon && (_jsx(DIcon, { icon: action.icon, className: "me-2", size: "1rem" })), action.label] })) : (_jsxs("button", { className: getItemClass(action), type: "button", onClick: () => {
                                var _a;
                                if (!action.disabled) {
                                    (_a = action.onClick) === null || _a === void 0 ? void 0 : _a.call(action);
                                    setOpen(false);
                                }
                            }, disabled: action.disabled, children: [action.icon && (_jsx(DIcon, { icon: action.icon, className: "me-2", size: "1rem" })), action.label] })) }, index));
                }) })] }));
}
//# sourceMappingURL=DDropdown.js.map